import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default ({
    namespaced: true,

    state: {
        familiaresSubsidios: [],
        // Cache interno keyed por tipoSubsidio ('1' = hijo, '2' = conyuge).
        // Evita refetch al navegar entre flows del mismo tipo. El getter publico
        // sigue siendo familiaresSubsidios — los componentes no ven este cache.
        familiaresSubsidiosCache: {},
        mediosPagos: [],
        validSub: null,
        successSubsidio: false,
        necesitaNota: false,
        validAportesPagos: false,
        validPlanPagos: false,
        // Catalogo de subsidios. sexosPermitidos define quien puede solicitarlos:
        // M solo puede acceder a los 4 generales; F y X acceden a los 6.
        catalogoSubsidios: [
            {
                value: 1,
                url: 'https://www.cajapsipba.org.ar/subsidio-maternidad.asp',
                title: 'Subsidio por maternidad',
                route: '/maternidad',
                subtitle: 'Art.47º b (Beneficio de Ley)',
                parrafo: 'El Subsidio por Maternidad está ligado con el período de descanso en los casos de maternidad de las afiliadas. Esta prestación consistirá en una asignación única que se abonará a la afiliada dentro de los cuarenta y cinco (45) días posteriores al parto. Según lo establecido por el artículo 68º de la ley 12163, los subsidios serán calculados en base al nivel de aportes en el último año completo inmediatamente anterior en que comienza a percibirse la prestación',
                sexosPermitidos: ['F', 'X'],
            },
            {
                value: 2,
                url: 'https://www.cajapsipba.org.ar/subsidio-maternidad.asp',
                title: 'Subsidio por madres no gestantes',
                route: '/madre_no_gestante',
                subtitle: '(Beneficio aprobado por Asamblea en el año 2019)',
                parrafo: 'La Asamblea Anual de Afiliados, aprobó la inclusión como beneficiarias del Subsidio por Maternidad consagrado en el artículo 47 inciso "b" de la Ley 12.163 a las afiliadas madres no gestantes que hayan obtenido a su favor una sentencia firme de adopción plena. Esta prestación consistirá en una asignación única que se abonará a la afiliada dentro de los cuarenta y cinco(45) días posteriores al nacimiento. Según lo establecido por el artículo 68º de la ley 12163, los subsidios serán calculados en base al nivel de aportes en el último año completo inmediatamente anterior en que comienza a percibirse la prestación',
                sexosPermitidos: ['F', 'X'],
            },
            {
                value: 3,
                url: 'https://www.cajapsipba.org.ar/subsidio-nacimiento.asp',
                title: 'Subsidio por nacimiento',
                route: '/nacimiento',
                subtitle: '(Beneficio aprobado por Asamblea en el año 2008)',
                parrafo: 'Esta prestación consiste en una asignación equivalente a 180 módulos. En caso de Nacimientos Múltiples, se establece por reglamento que se abonarán tantos subsidios como nacimientos se produzcan. En el caso que ambos padres sean afiliados a la Caja, corresponderá el pago a ambos progenitores.',
                sexosPermitidos: ['M', 'F', 'X'],
            },
            {
                value: 4,
                url: 'https://www.cajapsipba.org.ar/subsidio-adopcion.asp',
                title: 'Subsidio por adopción',
                route: '/adopcion',
                subtitle: '(Beneficio aprobado por Asamblea en el año 2008)',
                parrafo: 'Este subsidio consiste en una asignación equivalente a 180 módulos. En caso de adopciones múltiples, se establece por reglamento que se aboraran tantos subsidios como adopciones se produzcan. En el caso que ambos adoptantes sean afiliados de la Caja, correspondera a ambos',
                sexosPermitidos: ['M', 'F', 'X'],
            },
            {
                value: 5,
                url: 'https://www.cajapsipba.org.ar/subsidio-matrimonio.asp',
                title: 'Subsidio por matrimonio',
                route: '/matrimonio',
                subtitle: '(Beneficio aprobado por Asamblea en el año 2008)',
                parrafo: 'El Subsidio por Matrimonio consiste en una asignación equivalente a 180 módulos. En el caso que ambos contrayentes sean afiliados a la Caja, corresponderá el pago a ambos contrayentes',
                sexosPermitidos: ['M', 'F', 'X'],
            },
            {
                value: 6,
                url: 'https://www.cajapsipba.org.ar/subsidio-union.asp',
                title: 'Subsidio por unión convivencial',
                route: '/union-convivencial',
                subtitle: '(Beneficio aprobado por Asamblea en el año 2019)',
                parrafo: 'El Subsidio por Unión Convivencial consiste en una asignación equivalente a 180 módulos. Este beneficio se concede, sin excepción, a partir de la fecha de su creación (07/09/2019). En el caso que ambos contrayentes sean afiliados a la Caja, corresponderá el pago a ambos contrayentes.',
                sexosPermitidos: ['M', 'F', 'X'],
            },
        ],
    },
    getters: {
        familiaresSubsidios(state) {
            return state.familiaresSubsidios
        },
        mediosPagos(state) {
            return state.mediosPagos
        },
        validSub(state) {
            return state.validSub
        },
        successSubsidio(state) {
            return state.successSubsidio
        },
        necesitaNota(state) {
            return state.necesitaNota
        },
        validAportesPagos(state) {
            return state.validAportesPagos
        },
        validPlanPagos(state) {
            return state.validPlanPagos

        },
        // Subsidios visibles segun el sexo del usuario autenticado.
        // Si el sexo no es M/F/X (vacio, null, valor inesperado) se aplica
        // fallback permisivo: se muestran todos. La validacion final queda
        // delegada al backend al momento de solicitar el subsidio.
        subsidiosDisponibles(state, getters, rootState, rootGetters) {
            const sexo = rootGetters['auth/user']?.sexo
            if (!['M', 'F', 'X'].includes(sexo)) {
                return state.catalogoSubsidios
            }
            return state.catalogoSubsidios.filter(s => s.sexosPermitidos.includes(sexo))
        },
        subsidiosHabilitados() {
            return process.env.VUE_APP_SUBSIDIOS === 'true'
        }
    },
    mutations: {
        setSuccessSubsidio(state, payload) {
            state.successSubsidio = payload
        },
        setfamiliaresSubsidios(state, payload) {
            state.familiaresSubsidios = payload
        },
        cacheFamiliaresPorTipo(state, { tipo, data }) {
            // Reemplazo inmutable para mantener reactividad de Vuex.
            state.familiaresSubsidiosCache = {
                ...state.familiaresSubsidiosCache,
                [tipo]: data,
            }
        },
        setDataSubsidio(state, payload) {
            state.dataSubsidio = payload
        },
        setMediosPagos(state, payload) {
            state.mediosPagos = payload
        },
        setValidacionSub(state, payload) {
            state.validSub = payload
        },
        setNota(state, payload) {
            state.necesitaNota = payload
        },
        setValidAportesPagos(state, payload) {
            state.validAportesPagos = payload
        },
        setValidPlanPagos(state, payload) {
            state.validPlanPagos = payload
        }
    },
    /* 
    
                    case 'maternidadNacimiento':
                        $nuevoSubsidio = $this->nuevoSubsidioMaternidadNacimiento($datos, $args);
                        break;
                    case 'maternidadNoGestanteAdopcion':
                        $nuevoSubsidio = $this->nuevoSubsidioMaternidadNoGestanteAdopcion($datos, $args);
                        break;       
    
    */
    actions: {

        async solicitarSubsidiosAdopcion({ state, commit, dispatch }, formData) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/subsidios/adopcion',
                withCredentials: false,
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                data: formData,
            }).then((response) => {
                const res = response.data
                if (res.success) {
                    commit('setSuccessSubsidio', res.success)
                }

            }).catch(function (error) {
                console.log(error)
            }).finally(() => {
                commit('setSuccessSubsidio', false)
                dispatch('auth/setSktLoader', false, { root: true })
            })
        },
        async solicitarSubsidiosMaternidadNoGestante({ state, commit, dispatch }, formData) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/subsidios/maternidadNoGestanteAdopcion',
                withCredentials: false,
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                data: formData,
            }).then((response) => {
                const res = response.data
                if (res.success) {
                    commit('setSuccessSubsidio', res.success)
                }
            }).catch(function (error) {
                console.log(error)
            }).finally(() => {
                commit('setSuccessSubsidio', false)
                dispatch('auth/setSktLoader', false, { root: true })
            })
        },
        async solicitarSubsidiosMaternidad({ state, commit, dispatch }, formData) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/subsidios/maternidad',
                withCredentials: false,
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                data: formData,
            }).then((response) => {
                const res = response.data
                if (res.success) {
                    commit('setSuccessSubsidio', res.success)
                }
                return res.success; // Retorna solo el valor de `success`
                //console.log(res)

            }).catch(function (error) {
                console.log(error)
                return false // Retorna `false` en caso de error
            }).finally(() => {
                //capaz que tenga que poner en false
                commit('setSuccessSubsidio', false)
                dispatch('auth/setSktLoader', false, { root: true })
            })
        },
        async solicitarSubsidiosMaternidadNacimiento({ state, commit, dispatch }, formData) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/subsidios/maternidadNacimiento',
                withCredentials: false,
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                data: formData,
            }).then((response) => {
                const res = response.data
                if (res.success) {
                    commit('setSuccessSubsidio', res.success)
                }

            }).catch(function (error) {
                console.log(error)
            }).finally(() => {
                commit('setSuccessSubsidio', false)
                dispatch('auth/setSktLoader', false, { root: true })
            })
        },
        async solicitarSubsidiosMatrimonio({ state, commit, dispatch }, formData) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/subsidios/matrimonio',
                withCredentials: false,
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                data: formData,
            }).then((response) => {
                const res = response.data
                if (res.success) {
                    commit('setSuccessSubsidio', res.success)
                }
            }).catch(function (error) {
                console.log(error)
            }).finally(() => {
                commit('setSuccessSubsidio', false)
                dispatch('auth/setSktLoader', false, { root: true })

            })
        },
        async solicitarSubsidiosNacimiento({ state, commit, dispatch }, formData) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/subsidios/nacimiento',
                withCredentials: false,
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                data: formData,
            }).then((response) => {
                const res = response.data
                if (res.success) {
                    commit('setSuccessSubsidio', res.success)
                }

            }).catch(function (error) {
                console.log(error)
            }).finally(() => {
                commit('setSuccessSubsidio', false)
                dispatch('auth/setSktLoader', false, { root: true })
            })
        },
        /*
        {
            "validarTipoSubsidio": {
                "success": 0,
                "msg": "Rechazado: El plazo ha vencido de 180 d\u00edas de presentaci\u00f3n. Comun\u00edquese con el distrito.",
                "nota": 0
            }
}
        */
        async validarSubsidioAfiliado({ state, commit, dispatch }, payload) {
            try {
                const response = await axios({
                    method: 'post',
                    url: process.env.VUE_APP_API + 'portal/subsidios/validarTipoSubsidio',
                    withCredentials: false,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + sessionStorage.getItem('token')
                    },
                    data: payload,
                });
                const res = response.data.validarTipoSubsidio;
                console.log("validarTipoSubsidio: " + res)
                if (res.success) {
                    commit('setValidacionSub', res.success);
                    commit('setNota', res.nota)
                    if (payload.tipoSubsidio !== 'maternidad') {
                        dispatch('notificaciones/showSnack', {
                            message: res.msg,
                            type: "200",
                        }, { root: true })
                    }
                    return true;
                } else {
                    return false
                };
            } catch (error) {
                return false;
            }
        },
        async validarAportesPagos({ state, commit, dispatch }, payload) {
            try {
                const response = await axios({
                    method: 'post',
                    url: process.env.VUE_APP_API + 'portal/subsidios/validarAportesPagos',
                    withCredentials: false,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + sessionStorage.getItem('token')
                    },
                    data: payload,
                });
                const res = response.data;
                commit('setValidAportesPagos', !!res.success)
                if (res.success) return true;
                else return false
            } catch (error) {
                return false;
            } finally {
                dispatch('auth/setSktLoader', false, { root: true })
            }
        },
        async validarPlanPagos({ state, commit, dispatch }, payload) {
            try {
                const response = await axios({
                    method: 'post',
                    url: process.env.VUE_APP_API + 'portal/subsidios/validarPlanPagos',
                    withCredentials: false,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + sessionStorage.getItem('token')
                    },
                    data: payload,
                });
                const res = response.data;
                commit('setValidPlanPagos', !!res.success)
                if (res.success) return true;
                else return false
            } catch (error) {
                return false;
            } finally {
                dispatch('auth/setSktLoader', false, { root: true })
            }
        },
        async obtenerFamiliaresSubsidio({ state, commit, dispatch }, data) {
            /*
             POST ->  /subsidios/obtenerFamiliares
            const obj = {
                nroafi: '',
                tipoSubsidio: '1' // (1 hijo  / 2 conyuge)
                }
        */
            const tipo = data.tipoSubsidio
            const cached = state.familiaresSubsidiosCache[tipo]
            if (cached) {
                commit('setfamiliaresSubsidios', cached)
                dispatch('auth/setSktLoader', false, { root: true })
                return
            }
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/subsidios/obtenerFamiliares',
                withCredentials: false,
                data: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                }
            }).then((response) => {
                const res = response.data.familiares
                commit('setfamiliaresSubsidios', res)
                commit('cacheFamiliaresPorTipo', { tipo, data: res })
            }).catch(function (error) {
                console.log(error)
            }).finally(() => {
                dispatch('auth/setSktLoader', false, { root: true })

            })
        },
        async getMediosPaagos({ commit, dispatch }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/mediosPago',
                withCredentials: false,
                data: { nroafi: sessionStorage.getItem('nroafi'), incluirPre: 0 },
                headers: {
                    "Content-Type": "application/json",
                }
            })
                .then(function (response) {
                    const res = response.data.cbu
                    commit('setMediosPagos', res)
                })
                .catch(function (error) {
                }).finally(() => {
                    //dispatch('auth/setSktLoader', false, { root: true })
                });
        },
    },
})